<template>
    <!-- Create Sales Forecast -->
    <div class="page-salesforecast pb-15">
        <div class="d-flex align-items-center justify-content-center h-100" v-if="confirm_save_laoder">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
        </div>
        <div v-else>
            <div class="d-flex justify-content-between align-items-center">
                <div class="breadcrumbnew">
                    <a>Sales Forecasting</a>
                    <span>Create New</span>
                </div>
                <div class="mr-4" v-if="deleteIds.length">
                    <button href="javascript:;" class="btn btn-xlg btn-new-primary" @click="deleteAll()">
                        <i class="icon-trash iconsize-18 mr-2"></i>Delete Selected Item
                    </button>
                </div>
            </div>
            <div class="card p-5 pb-10">
                <div class="page-header newheight p-5" style=".box:hover .inner_box {-webkit-box-shadow: none;-moz-box-shadow: none;box-shadow: none;}">
                    <div>
                        <div class="card-salesForescast first-cardsales">
                            <div class="headerBlocksSales " style="background-color:#005dae; height:60px;">
                                <div class="headerBlocksSales-label ">
                                    <h2 class="d-flex">
                                        <v-select label="name" index="id" class="vselect-custom select-white"
                                            placeholder="Select" :clearable="false" name="forecast" :filterable="true"
                                            v-model="forecastOrCurrent" :options="dType" style="width: 200px;"></v-select>
                                    </h2>
                                </div>
                            </div>
                            <div class>
                                <div class="row px-12 pt-3 pb-4">
                                    <div class="col-lg-3 pt-4">
                                        <div class>
                                            <span class="text-black whiteSpace vselectLabel fw-600">Company Name<sup class="fs-14 ml-02 mandatory">*</sup></span>
                                            <multiselect v-validate="'required'" :max-height="250"
                                                class="digi-multiselect loaderbgwhite" @open="fetchCustomers"
                                                @search-change="fetchCustomers"
                                                @close="updateBranch(selectCompany);search_key = ''"
                                                @select="clearBranchDept" :loading="loadingCompany" v-model="selectCompany"
                                                :searchable="true" placeholder="Select Company Name" label="company_name"
                                                :options="customers" :multiple="false" :taggable="false"
                                                :close-on-select="true" :show-labels="false" :clear-on-select="false"
                                                :hide-selected="true" name="companies">
                                                <template slot="tag" slot-scope="{ option, remove }">
                                                    <span class="custom__tag">
                                                        <span>{{ option.company_name }}</span>
                                                        <span class="custom__remove" @click="remove(option)">
                                                            <i class="icon-close iconsize-16 defaultDarkBlue"></i>
                                                        </span>
                                                    </span>
                                                </template>
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfListCustomer" />
                                                </template>
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">List is Empty</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                        </div>
                                        <span class="invalid-feedback-form text-danger text-left mt-0"
                                            style="text-transform: none !important;"
                                            v-show="errors.has('companies')">Company Name is Required</span>
                                    </div>
                                    <div class="col-lg-3 pt-4">
                                        <div class :class="{'dateDisable':selectCompany == ''}">
                                            <span class="text-black whiteSpace vselectLabel fw-600">Branch Name<sup
                                                    class="fs-14 ml-02 mandatory">*</sup></span>
                                            <multiselect @close="updateDept(branchName)" label="name"
                                                v-validate="'required'" :max-height="250"
                                                class="digi-multiselect loaderbgwhite" v-model="branchName"
                                                :block-keys="['Tab']" :searchable="true" placeholder="Select Branch Name"
                                                :options="branchs" :multiple="false" :taggable="false"
                                                :close-on-select="true" :show-labels="false" :clear-on-select="false"
                                                :hide-selected="false" name="branches">
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600" v-if="selectCompany == ''">Please Select Company</div>
                                                    <div class="text-secondary text-center fw-600" v-else>Branches Not Found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                        </div>
                                        <span class="invalid-feedback-form text-danger text-left mt-0"
                                            style="text-transform: none !important;" v-show="errors.has('branches')">Branch
                                            Name is Required</span>
                                    </div>
                                    <div class="col-lg-3 pt-4">
                                        <div class>
                                            <span class="text-black whiteSpace vselectLabel fw-600">Department Name<sup
                                                    class="fs-14 ml-02 mandatory">*</sup></span>
                                            <multiselect v-validate="'required'" :max-height="250"
                                                class="digi-multiselect loaderbgwhite" v-model="departmentName"
                                                :block-keys="['Tab']" :searchable="true"
                                                placeholder="Select Department Name" :options="departments"
                                                :multiple="false" :taggable="false" :close-on-select="true"
                                                :show-labels="false" :clear-on-select="false" :hide-selected="false"
                                                name="dept">
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">Departments Not Found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                        </div>
                                        <span class="invalid-feedback-form text-danger text-left mt-0"
                                            style="text-transform: none !important;" v-show="errors.has('dept')">Department
                                            Name is Required</span>
                                    </div>
                                    <div class="col-lg-3 pt-4">
                                        <div class>
                                            <span class="text-black whiteSpace vselectLabel fw-600">
                                                Fiscal Year
                                                <el-tooltip class="item" effect="dark" content="Select Year"
                                                    placement="top">
                                                    <i class="icon-information text-secondary iconsize-18 ml-3"></i>
                                                </el-tooltip>
                                            </span>
                                            <div class="d-flex flex-column" style="width:100%">
                                                <el-dropdown trigger="click" :hide-on-click="hide_el_dropdown"
                                                    @visible-change="dropdownTriggered"
                                                    style="border-bottom: 1px solid #a9aaad; line-height: 35px;">
                                                    <span class="mr-1"
                                                        style="font-weight: 600; color: #303031; width: 100%; display: block"
                                                        :style="target_year == 'Select Year' ? 'font-weight: normal !important; color: #7b7f83 !important; font-size: 13px' : ''">
                                                        <span>{{target_year}}</span>
                                                    </span>
                                                    <el-dropdown-menu slot="dropdown" class="fiscal-year-el">
                                                        <el-dropdown-item
                                                            class="d-flex justify-content-between align-items-center">
                                                            <i class="icon-chevron-double-left m-0" @click="yearPrev"></i>
                                                            <span
                                                                style="font-size: 12px; font-weight: 400">{{years_to_set[0]}}
                                                                - {{years_to_set[5]}}</span>
                                                            <i class="icon-chevron-double-right m-0" @click="yearNext"></i>
                                                        </el-dropdown-item>
                                                        <el-dropdown-item
                                                            class="d-flex flex-column justify-content-center align-items-center">
                                                            <span
                                                                :class="{ 'selectedYear':target_year_selected == `${years_to_set[0]}-${years_to_set[1]}` }"
                                                                @click="yearClicked(years_to_set[0], years_to_set[1])">{{years_to_set[0]}}
                                                                - {{years_to_set[1]}}</span>
                                                            <span
                                                                :class="{ 'selectedYear':target_year_selected == `${years_to_set[1]}-${years_to_set[2]}` }"
                                                                @click="yearClicked(years_to_set[1], years_to_set[2])">{{years_to_set[1]}}
                                                                - {{years_to_set[2]}}</span>
                                                            <span
                                                                :class="{ 'selectedYear':target_year_selected == `${years_to_set[2]}-${years_to_set[3]}` }"
                                                                @click="yearClicked(years_to_set[2], years_to_set[3])">{{years_to_set[2]}}
                                                                - {{years_to_set[3]}}</span>
                                                            <span
                                                                :class="{ 'selectedYear':target_year_selected == `${years_to_set[3]}-${years_to_set[4]}` }"
                                                                @click="yearClicked(years_to_set[3], years_to_set[4])">{{years_to_set[3]}}
                                                                - {{years_to_set[4]}}</span>
                                                            <span
                                                                :class="{ 'selectedYear':target_year_selected == `${years_to_set[4]}-${years_to_set[5]}` }"
                                                                @click="yearClicked(years_to_set[4], years_to_set[5])">{{years_to_set[4]}}
                                                                - {{years_to_set[5]}}</span>
                                                            <a href="javascript:;"
                                                                class="btn btn-new-primary btn-xsm mt-2 mb-4"
                                                                @click="applyFiscalYear">Apply</a>
                                                        </el-dropdown-item>
                                                    </el-dropdown-menu>
                                                </el-dropdown>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-3 pt-4">
                                        <div class>
                                            <span class="text-black whiteSpace vselectLabel fw-600">Main Sales Person</span>
                                            <multiselect :max-height="250" class="digi-multiselect loaderbgwhite"
                                                v-model="mainSalesPerson" :block-keys="['Tab']" :searchable="true"
                                                placeholder="Select Main Sales Person" @open="fetchSalesPerson"
                                                @search-change="fetchSalesPerson" @close="closeMultiselect"
                                                :loading="loadingSalesPerson" :options="salesperson" label="full_name"
                                                :multiple="false" :taggable="false" :close-on-select="true"
                                                :show-labels="false" :clear-on-select="false" :hide-selected="false">
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">Main Sales Person Not Found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div class="px-12 py-1">
                                    <div style="overflow: auto">
                                        <table class="table table-new-template head-sub sales-forecast-table">
                                            <thead>
                                                <tr>
                                                    <th class="head"
                                                        style="padding: 1.9rem 0.2rem 1.1rem 1.2rem !important;">
                                                        <label class="custom-control custom-checkbox digi-checkbox"
                                                            style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                                            <input v-model="selectAll" @click="clickedSelectAll()"
                                                                type="checkbox" class="custom-control-input" />
                                                            <span class="custom-control-indicator"
                                                                style="top: -5px !important;font-size: 20px;color: #fff !important;"></span>
                                                            <span class="form-check-description fw-600"></span>
                                                        </label>
                                                    </th>
                                                    <th class="head">Reference</th>
                                                    <th class="head">Product Name</th>
                                                    <th class="head">Sales Person</th>
                                                    <th class="head" style="white-space:none !important;"> Product Code</th>
                                                    <th class="head">UM</th>
                                                    <th class="head">
                                                        <span class="d-flex flex-column align-items-center">
                                                            <span>Jan</span>
                                                            <span v-if="quantityOnOff"
                                                                class="d-flex justify-content-between"
                                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                                <span>Qty</span>
                                                                <span>|</span>
                                                                <span>Val</span>
                                                            </span>
                                                        </span>
                                                    </th>
                                                    <th class="head">
                                                        <span class="d-flex flex-column align-items-center">
                                                            <span>Feb</span>
                                                            <span v-if="quantityOnOff"
                                                                class="d-flex justify-content-between"
                                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                                <span>Qty</span>
                                                                <span>|</span>
                                                                <span>Val</span>
                                                            </span>
                                                        </span>
                                                    </th>
                                                    <th class="head">
                                                        <span class="d-flex flex-column align-items-center">
                                                            <span>Mar</span>
                                                            <span v-if="quantityOnOff"
                                                                class="d-flex justify-content-between"
                                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                                <span>Qty</span>
                                                                <span>|</span>
                                                                <span>Val</span>
                                                            </span>
                                                        </span>
                                                    </th>
                                                    <th class="head">
                                                        <span class="d-flex flex-column align-items-center">
                                                            <span>Apr</span>
                                                            <span v-if="quantityOnOff"
                                                                class="d-flex justify-content-between"
                                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                                <span>Qty</span>
                                                                <span>|</span>
                                                                <span>Val</span>
                                                            </span>
                                                        </span>
                                                    </th>
                                                    <th class="head">
                                                        <span class="d-flex flex-column align-items-center">
                                                            <span>May</span>
                                                            <span v-if="quantityOnOff"
                                                                class="d-flex justify-content-between"
                                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                                <span>Qty</span>
                                                                <span>|</span>
                                                                <span>Val</span>
                                                            </span>
                                                        </span>
                                                    </th>
                                                    <th class="head">
                                                        <span class="d-flex flex-column align-items-center">
                                                            <span>Jun</span>
                                                            <span v-if="quantityOnOff"
                                                                class="d-flex justify-content-between"
                                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                                <span>Qty</span>
                                                                <span>|</span>
                                                                <span>Val</span>
                                                            </span>
                                                        </span>
                                                    </th>
                                                    <th class="head">
                                                        <span class="d-flex flex-column align-items-center">
                                                            <span>Jul</span>
                                                            <span v-if="quantityOnOff"
                                                                class="d-flex justify-content-between"
                                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                                <span>Qty</span>
                                                                <span>|</span>
                                                                <span>Val</span>
                                                            </span>
                                                        </span>
                                                    </th>
                                                    <th class="head">
                                                        <span class="d-flex flex-column align-items-center">
                                                            <span>Aug</span>
                                                            <span v-if="quantityOnOff"
                                                                class="d-flex justify-content-between"
                                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                                <span>Qty</span>
                                                                <span>|</span>
                                                                <span>Val</span>
                                                            </span>
                                                        </span>
                                                    </th>
                                                    <th class="head">
                                                        <span class="d-flex flex-column align-items-center">
                                                            <span>Sept</span>
                                                            <span v-if="quantityOnOff"
                                                                class="d-flex justify-content-between"
                                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                                <span>Qty</span>
                                                                <span>|</span>
                                                                <span>Val</span>
                                                            </span>
                                                        </span>
                                                    </th>
                                                    <th class="head">
                                                        <span class="d-flex flex-column align-items-center">
                                                            <span>Oct</span>
                                                            <span v-if="quantityOnOff"
                                                                class="d-flex justify-content-between"
                                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                                <span>Qty</span>
                                                                <span>|</span>
                                                                <span>Val</span>
                                                            </span>
                                                        </span>
                                                    </th>
                                                    <th class="head">
                                                        <span class="d-flex flex-column align-items-center">
                                                            <span>Nov</span>
                                                            <span v-if="quantityOnOff"
                                                                class="d-flex justify-content-between"
                                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                                <span>Qty</span>
                                                                <span>|</span>
                                                                <span>Val</span>
                                                            </span>
                                                        </span>
                                                    </th>
                                                    <th class="head">
                                                        <span class="d-flex flex-column align-items-center">
                                                            <span>Dec</span>
                                                            <span v-if="quantityOnOff"
                                                                class="d-flex justify-content-between"
                                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                                <span>Qty</span>
                                                                <span>|</span>
                                                                <span>Val</span>
                                                            </span>
                                                        </span>
                                                    </th>
                                                    <!-- <th></th> -->
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(pr,index) in target" :key="index">
                                                    <td style="padding: 1.6rem 0.2rem 1.6rem 1.2rem !important;">
                                                        <label class="custom-control custom-checkbox digi-checkbox"
                                                            style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                                            <input v-model="deleteIds" :value="index"
                                                                @click="handleDeleteIds(index)" type="checkbox"
                                                                class="custom-control-input" />
                                                            <span class="custom-control-indicator"
                                                                style="font-size: 20px;top: -10px !important;"></span>
                                                            <span class="form-check-description fw-600"></span>
                                                        </label>
                                                    </td>
                                                    <td>
                                                        <div class="forecastSumInput createsfinput">
                                                            <input v-validate="'required'" data-vv-as="Reference" class="inputFieldTableSalesList"
                                                                :name="'reference'+index" v-model="pr.reference" type="text"
                                                                placeholder="Enter Reference" disabled required />
                                                        </div>
                                                        <span class="invalid-feedback-form text-danger text-left text-capitalize mt-0"
                                                            style="margin-top: 0;font-weight: 400;"
                                                            v-show="errors.has('reference'+index)">{{errors.first('reference'+index)}}</span>
                                                    </td>
                                                    <td>
                                                        <div class="forecastSumInput createsfinput"
                                                            style="width: 15em; display: flex; overflow: hidden;">
                                                            <input v-validate="'required'" data-vv-as="Product Name"
                                                                class="inputFieldTableSalesList fw-500 pointer"
                                                                :name="'product_name'+index" v-model="pr.product.name"
                                                                type="text" readonly placeholder="Select Product Name"
                                                                autocomplete="off" id="myAnchor"
                                                                @focus="selectProductDropdown(index,'')"
                                                                style="padding-right: 20px !important; text-overflow: ellipsis" />
                                                            <i class="icon-menu-down"
                                                                @click="selectProductDropdown(index,'')"
                                                                style="margin-top: 5px; margin-left: -25px; color: #999"></i>
                                                        </div>
                                                        <span class="invalid-feedback-form text-danger text-left text-capitalize mt-0"
                                                            style="margin-top: 0;font-weight: 400;"
                                                            v-show="errors.has('product_name'+index)">{{errors.first('product_name'+index)}}</span>
                                                    </td>
                                                    <td>
                                                        <div class="forecastSumInput createsfinput"
                                                            style="width: 15em; display: flex; overflow: hidden;">
                                                            <input v-validate="'required'"
                                                                class="inputFieldTableSalesList fw-500 pointer"
                                                                :name="'sales_person'+index" data-vv-as="Sales Person"
                                                                v-model="pr.sales_person.full_name" type="text"
                                                                placeholder="Select Sales Person" autocomplete="off"
                                                                readonly id="myAnchor"
                                                                @focus="selectSalesPersonDropdown(index,'sales_person')"
                                                                style="padding-right: 20px !important; text-overflow: ellipsis" />
                                                            <i class="icon-menu-down"
                                                                @click="selectSalesPersonDropdown(index,'sales_person')"
                                                                style="margin-top: 5px; margin-left: -25px; color: #999"></i>
                                                        </div>
                                                        <span class="invalid-feedback-form text-danger text-left text-capitalize mt-0"
                                                            style="margin-top: 0;font-weight: 400;"
                                                            v-show="errors.has('sales_person'+index)">{{errors.first('sales_person'+index)}}</span>
                                                    </td>
                                                    <td>
                                                        <div class="forecastSumInput createsfinput">
                                                            <input v-validate="'required'"
                                                                class="inputFieldTableSalesList fw-500"
                                                                :name="'product_code'+index" data-vv-as="Product Code"
                                                                v-model="pr.product.product_code" type="text"
                                                                placeholder="Enter Product Code" />
                                                        </div>
                                                        <span class="invalid-feedback-form text-danger text-left text-capitalize mt-0"
                                                            style="margin-top: 0;font-weight: 400;"
                                                            v-show="errors.has('product_code'+index) && !pr.product_code">{{errors.first('product_code'+index)}}</span>
                                                    </td>
                                                    <td>
                                                        <div class="forecastSumInput createsfinput"
                                                            style="width: 10em; display: flex; overflow: hidden;">
                                                            <input v-validate="'required'"
                                                                class="inputFieldTableSalesList fw-500 pointer"
                                                                :name="'um'+index" v-model="pr.uom" type="text" readonly
                                                                placeholder="Select UM" autocomplete="off" id="myAnchor"
                                                                @focus="selectUMDropdown(index,'')" data-vv-as="UM"
                                                                style="padding-right: 20px !important; text-overflow: ellipsis" />
                                                            <i class="icon-menu-down"
                                                                @click="selectUMDropdown(index,'')"
                                                                style="margin-top: 5px; margin-left: -25px; color: #999"></i>
                                                        </div>
                                                        <span class="invalid-feedback-form text-danger text-left text-capitalize mt-0"
                                                            style="margin-top: 0;font-weight: 400;"
                                                            v-show="errors.has('um'+index)">{{errors.first('um'+index)}}</span>
                                                    </td>
                                                    <td>
                                                        <span class="d-flex text-center" style="min-width: 160px;">
                                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            :class="{ inputFieldTableSalesListError: pr.target.jan_quantity > 99999 }"
                                                                            @input="sum('jan')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'qty_jan'+index"
                                                                            v-model.number="pr.target.jan_quantity"
                                                                            type="text" placeholder="Add Qty" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('qty_jan'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                            <span class="text-center" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <label
                                                                            style="padding-top: 5px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            @input="sum('jan')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'target_jan'+index"
                                                                            v-model.number="pr.target.jan" type="text"
                                                                            placeholder="Add Value" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left ml-5"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('target_jan'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span class="d-flex text-center" style="min-width: 160px;">
                                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            :class="{ inputFieldTableSalesListError: pr.target.feb_quantity > 99999 }"
                                                                            @input="sum('feb')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'qty_feb'+index"
                                                                            v-model.number="pr.target.feb_quantity"
                                                                            type="text" placeholder="Add Qty" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('qty_feb'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                            <span class="text-center" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <label
                                                                            style="padding-top: 5px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            @input="sum('feb')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'target_feb'+index"
                                                                            v-model.number="pr.target.feb" type="text"
                                                                            placeholder="Add Value" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left ml-5"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('target_feb'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span class="d-flex text-center" style="min-width: 160px;">
                                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            :class="{ inputFieldTableSalesListError: pr.target.mar_quantity > 99999 }"
                                                                            @input="sum('mar')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'qty_mar'+index"
                                                                            v-model.number="pr.target.mar_quantity"
                                                                            type="text" placeholder="Add Qty" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('qty_mar'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                            <span class="text-center" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <label
                                                                            style="padding-top: 5px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            @input="sum('mar')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'target_jan'+index"
                                                                            v-model.number="pr.target.mar" type="text"
                                                                            placeholder="Add Value" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left ml-5"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('target_mar'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span class="d-flex text-center" style="min-width: 160px;">
                                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            :class="{ inputFieldTableSalesListError: pr.target.apr_quantity > 99999 }"
                                                                            @input="sum('apr')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'qty_apr'+index"
                                                                            v-model.number="pr.target.apr_quantity"
                                                                            type="text" placeholder="Add Qty" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('qty_apr'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                            <span class="text-center" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <label
                                                                            style="padding-top: 5px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            @input="sum('apr')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'target_apr'+index"
                                                                            v-model.number="pr.target.apr" type="text"
                                                                            placeholder="Add Value" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left ml-5"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('target_apr'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span class="d-flex text-center" style="min-width: 160px;">
                                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            :class="{ inputFieldTableSalesListError: pr.target.may_quantity > 99999 }"
                                                                            @input="sum('may')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'qty_may'+index"
                                                                            v-model.number="pr.target.may_quantity"
                                                                            type="text" placeholder="Add Qty" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('qty_may'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                            <span class="text-center" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <label
                                                                            style="padding-top: 5px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            @input="sum('may')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'target_may'+index"
                                                                            v-model.number="pr.target.may" type="text"
                                                                            placeholder="Add Value" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left ml-5"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('target_may'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span class="d-flex text-center" style="min-width: 160px;">
                                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            :class="{ inputFieldTableSalesListError: pr.target.jun_quantity > 99999 }"
                                                                            @input="sum('jun')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'qty_jun'+index"
                                                                            v-model.number="pr.target.jun_quantity"
                                                                            type="text" placeholder="Add Qty" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('qty_jun'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                            <span class="text-center" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <label
                                                                            style="padding-top: 5px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            @input="sum('jun')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'target_jun'+index"
                                                                            v-model.number="pr.target.jun" type="text"
                                                                            placeholder="Add Value" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left ml-5"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('target_jun'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span class="d-flex text-center" style="min-width: 160px;">
                                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            :class="{ inputFieldTableSalesListError: pr.target.jul_quantity > 99999 }"
                                                                            @input="sum('jul')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'qty_jul'+index"
                                                                            v-model.number="pr.target.jul_quantity"
                                                                            type="text" placeholder="Add Qty" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('qty_jul'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                            <span class="text-center" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <label
                                                                            style="padding-top: 5px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            @input="sum('jul')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'target_jul'+index"
                                                                            v-model.number="pr.target.jul" type="text"
                                                                            placeholder="Add Value" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left ml-5"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('target_jul'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span class="d-flex text-center" style="min-width: 160px;">
                                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            :class="{ inputFieldTableSalesListError: pr.target.aug_quantity > 99999 }"
                                                                            @input="sum('aug')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'qty_aug'+index"
                                                                            v-model.number="pr.target.aug_quantity"
                                                                            type="text" placeholder="Add Qty" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('qty_aug'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                            <span class="text-center" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <label
                                                                            style="padding-top: 5px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            @input="sum('aug')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'target_aug'+index"
                                                                            v-model.number="pr.target.aug" type="text"
                                                                            placeholder="Add Value" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left ml-5"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('target_aug'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span class="d-flex text-center" style="min-width: 160px;">
                                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            :class="{ inputFieldTableSalesListError: pr.target.sept_quantity > 99999 }"
                                                                            @input="sum('sept')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'qty_sept'+index"
                                                                            v-model.number="pr.target.sept_quantity"
                                                                            type="text" placeholder="Add Qty" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('qty_sept'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                            <span class="text-center" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <label
                                                                            style="padding-top: 5px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            @input="sum('sept')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'target_sept'+index"
                                                                            v-model.number="pr.target.sept" type="text"
                                                                            placeholder="Add Value" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left ml-5"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('target_sept'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span class="d-flex text-center" style="min-width: 160px;">
                                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            :class="{ inputFieldTableSalesListError: pr.target.oct_quantity > 99999 }"
                                                                            @input="sum('oct')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'qty_oct'+index"
                                                                            v-model.number="pr.target.oct_quantity"
                                                                            type="text" placeholder="Add Qty" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('qty_oct'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                            <span class="text-center" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <label
                                                                            style="padding-top: 5px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            @input="sum('oct')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'target_oct'+index"
                                                                            v-model.number="pr.target.oct" type="text"
                                                                            placeholder="Add Value" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left ml-5"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('target_oct'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span class="d-flex text-center" style="min-width: 160px;">
                                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            :class="{ inputFieldTableSalesListError: pr.target.nov_quantity > 99999 }"
                                                                            @input="sum('nov')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'qty_nov'+index"
                                                                            v-model.number="pr.target.nov_quantity"
                                                                            type="text" placeholder="Add Qty" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('qty_nov'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                            <span class="text-center" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <label
                                                                            style="padding-top: 5px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            @input="sum('nov')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'target_nov'+index"
                                                                            v-model.number="pr.target.nov" type="text"
                                                                            placeholder="Add Value" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left ml-5"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('target_nov'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span class="d-flex text-center" style="min-width: 160px;">
                                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            :class="{ inputFieldTableSalesListError: pr.target.dec_quantity > 99999 }"
                                                                            @input="sum('dec')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'qty_dec'+index"
                                                                            v-model.number="pr.target.dec_quantity"
                                                                            type="text" placeholder="Add Qty" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('qty_dec'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                            <span class="text-center" style="min-width: 50%">
                                                                <span>
                                                                    <div class="d-flex createsfinput">
                                                                        <label
                                                                            style="padding-top: 5px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                                        <input v-validate="'required'"
                                                                            class="inputFieldTableSalesList"
                                                                            @input="sum('dec')"
                                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                            :name="'target_dec'+index"
                                                                            v-model.number="pr.target.dec" type="text"
                                                                            placeholder="Add Value" required />
                                                                    </div>
                                                                    <span
                                                                        class="invalid-feedback-form text-danger text-left ml-5"
                                                                        style="text-transform: none !important;margin-top: 0px;"
                                                                        v-show="errors.has('target_dec'+index)">Required</span>
                                                                </span>
                                                            </span>
                                                        </span>
                                                    </td>
                                                    <!-- <td @click="target.splice(index, 1)" v-if="index!=0">
                                                    <i class="icon-trash text-secondary iconsize-18"></i>
                        </td>-->
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td style="border-radius: 7.5px 0px 0px 7.5px;"></td>
                                                    <td class="font-weight-bold" style="text-align: left !important">Total
                                                    </td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td class="font-weight-bold">
                                                        <span class="d-flex text-center" style="min-width: 160px">
                                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                                            <span class="text-left"
                                                                style="min-width: 50%; margin-left: 10px;">{{selectedCompany.currency.symbol}}
                                                                {{formatPrice(totalOfMonth.jan)}}</span>
                                                        </span>
                                                    </td>
                                                    <td class="font-weight-bold">
                                                        <span class="d-flex text-center" style="min-width: 160px">
                                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                                            <span class="text-left"
                                                                style="min-width: 50%; margin-left: 10px;">{{selectedCompany.currency.symbol}}
                                                                {{formatPrice(totalOfMonth.feb)}}</span>
                                                        </span>
                                                    </td>
                                                    <td class="font-weight-bold">
                                                        <span class="d-flex text-center" style="min-width: 160px">
                                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                                            <span class="text-left"
                                                                style="min-width: 50%; margin-left: 10px;">{{selectedCompany.currency.symbol}}
                                                                {{formatPrice(totalOfMonth.mar)}}</span>
                                                        </span>
                                                    </td>
                                                    <td class="font-weight-bold">
                                                        <span class="d-flex text-center" style="min-width: 160px">
                                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                                            <span class="text-left"
                                                                style="min-width: 50%; margin-left: 10px;">{{selectedCompany.currency.symbol}}
                                                                {{formatPrice(totalOfMonth.apr)}}</span>
                                                        </span>
                                                    </td>
                                                    <td class="font-weight-bold">
                                                        <span class="d-flex text-center" style="min-width: 160px">
                                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                                            <span class="text-left"
                                                                style="min-width: 50%; margin-left: 10px;">{{selectedCompany.currency.symbol}}
                                                                {{formatPrice(totalOfMonth.may)}}</span>
                                                        </span>
                                                    </td>
                                                    <td class="font-weight-bold">
                                                        <span class="d-flex text-center" style="min-width: 160px">
                                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                                            <span class="text-left"
                                                                style="min-width: 50%; margin-left: 10px;">{{selectedCompany.currency.symbol}}
                                                                {{formatPrice(totalOfMonth.jun)}}</span>
                                                        </span>
                                                    </td>
                                                    <td class="font-weight-bold">
                                                        <span class="d-flex text-center" style="min-width: 160px">
                                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                                            <span class="text-left"
                                                                style="min-width: 50%; margin-left: 10px;">{{selectedCompany.currency.symbol}}
                                                                {{formatPrice(totalOfMonth.jul)}}</span>
                                                        </span>
                                                    </td>
                                                    <td class="font-weight-bold">
                                                        <span class="d-flex text-center" style="min-width: 160px">
                                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                                            <span class="text-left"
                                                                style="min-width: 50%; margin-left: 10px;">{{selectedCompany.currency.symbol}}
                                                                {{formatPrice(totalOfMonth.aug)}}</span>
                                                        </span>
                                                    </td>
                                                    <td class="font-weight-bold">
                                                        <span class="d-flex text-center" style="min-width: 160px">
                                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                                            <span class="text-left"
                                                                style="min-width: 50%; margin-left: 10px;">{{selectedCompany.currency.symbol}}
                                                                {{formatPrice(totalOfMonth.sept)}}</span>
                                                        </span>
                                                    </td>
                                                    <td class="font-weight-bold">
                                                        <span class="d-flex text-center" style="min-width: 160px">
                                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                                            <span class="text-left"
                                                                style="min-width: 50%; margin-left: 10px;">{{selectedCompany.currency.symbol}}
                                                                {{formatPrice(totalOfMonth.oct)}}</span>
                                                        </span>
                                                    </td>
                                                    <td class="font-weight-bold">
                                                        <span class="d-flex text-center" style="min-width: 160px">
                                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                                            <span class="text-left"
                                                                style="min-width: 50%; margin-left: 10px;">{{selectedCompany.currency.symbol}}
                                                                {{formatPrice(totalOfMonth.nov)}}</span>
                                                        </span>
                                                    </td>
                                                    <td class="font-weight-bold">
                                                        <span class="d-flex text-center" style="min-width: 160px">
                                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                                            <span class="text-left"
                                                                style="min-width: 50%; margin-left: 10px;">{{selectedCompany.currency.symbol}}
                                                                {{formatPrice(totalOfMonth.dec)}}</span>
                                                        </span>
                                                    </td>
                                                    <!-- <td></td> -->
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    <div v-if="!ajaxCallinprogress" class="mt-4">
                                        <button class="btn-table"
                                            @click="target.push(JSON.parse(JSON.stringify(newtarget)))">+ Add
                                            Product</button>
                                    </div>
                                    <div v-if="!ajaxCallinprogress" class="mt-10 mx-10">
                                        <div class="form-group">
                                            <input class="inputField" style="margin-top:5px;" v-model="notes" type="text"
                                                placeholder="Add Notes" required />
                                            <span class="inputBorder"></span>
                                            <label class="inputLabel fs-14 fw-800"
                                                style="color: #303031 !important;top: 0px !important;">Notes</label>
                                        </div>
                                    </div>
                                    <div v-if="!ajaxCallinprogress" class="mt-10 mx-10">
                                        <span class="fs-14 fw-800"
                                            style="color: #303031 !important;top: 0px !important;">Attachments</span>
                                    </div>
                                    <div v-if="!ajaxCallinprogress" class="mt-2">
                                        <div class="form-group">
                                            <div class="attachment mt-5">
                                                <span class="d-flex justify-content-center text-white fw-600 fs-14 py-4"
                                                    style="border-top-left-radius: 12px; border-top-right-radius: 12px; background: #00448b;">ADD
                                                    ATTACHMENTS</span>
                                                <div class="upload-main d-flex flex-column justify-content-center align-items-center pl-0 pt-5 pb-5"
                                                    style="background: #f5f5f5; border-bottom-left-radius: 6px; border-bottom-right-radius: 6px;">
                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/upload-icon.svg"
                                                        style="width: 3.5em; height: 3.5em">
                                                    <span class="fs-12 fw-500 mt-2">
                                                        Drag and Drop File
                                                        <sup class="fs-14 ml-02 mandatory">
                                                            <el-tooltip effect="dark" placement="left" style="width: 21em;">
                                                                <div slot="content" style="color: #fff; font-size: 12px;">
                                                                    <span style="font-weight: 600;">Select a Lead Contact if
                                                                        already exists <br> in the dropdown, else add a Lead
                                                                        <br> Contact here.</span>
                                                                </div>
                                                                <i class="icon-information text-secondary"
                                                                    style="font-size: 15px;"></i>
                                                            </el-tooltip>
                                                        </sup>
                                                    </span>
                                                    <span>File Type : Document<span style="color: #00448b">- ( File Limit :
                                                            10 Files of 10 MB Each ) </span></span>
                                                    <span>File Type : Image<span style="color: #00448b">- ( File Limit : 10
                                                            files of 10 MB each )</span></span>
                                                    <span>File Type : Video/Audio <span style="color: #00448b">- ( File
                                                            Limit : 10 files of 10 MB each ) </span></span>
                                                    <span class="fs-12 fw-500 mt-2">or</span>
                                                    <file-upload class="choose-file btn btn-des-small mt-2" :multiple="true"
                                                        :drop="true" :drop-directory="true" @input-file="uploadAttachment"
                                                        ref="upload"
                                                        style="text-transform: none !important; color: #fff; background: #1c61c2; border: 1px solid #1c61c2; width: 8em;">
                                                        Browse
                                                    </file-upload>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="attachments.length" class="col-9 pr-0"
                                            style="height: 18em; overflow: auto;">
                                            <div class="attachmentsdiv p-4 my-2" v-for="(attachment,index) in attachments"
                                                :key="index">
                                                <div class="d-flex align-items-center justify-content-between">
                                                    <div class="d-flex align-items-center">
                                                        <div>
                                                            <img v-if="attachment.name.endsWith('.pdf')"
                                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg" />
                                                            <img v-else-if="attachment.name.endsWith('.png')"
                                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg" />
                                                            <img v-else-if="attachment.name.endsWith('.jpg')"
                                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg" />
                                                            <img v-else-if="attachment.name.endsWith('.svg')"
                                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                                            <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')"
                                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg" />
                                                            <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')"
                                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg" />
                                                        </div>
                                                        <div class="col">
                                                            <div class="d-flex justify-content-between">
                                                                <el-tooltip :content="attachment.name" placement="top">
                                                                    <div
                                                                        class="font-weight-bold text-truncate d-block mx-width-220">
                                                                        {{attachment.name}}</div>
                                                                </el-tooltip>
                                                            </div>
                                                            <div v-if="attachment.uploading || attachment.url == undefined">
                                                                <progress-bar class="progressBar w-100"
                                                                    :class="{'error-upload':attachment.url == undefined}"
                                                                    :val="attachment.progress" size="small"></progress-bar>
                                                            </div>
                                                            <div class="d-flex justify-content-between">
                                                                <div class="text-danger pl-0 fw-500"
                                                                    v-if="attachment.error != ''">{{attachment.error}}...
                                                                </div>
                                                                <div class="text-secondary fw-500"
                                                                    v-if="attachment.progress<100 && attachment.error == ''">
                                                                    {{attachment.progress}}% Uploaded</div>
                                                                <div class="fw-500">({{attachment.size | prettyBytes}})
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="attachment.uploading || attachment.url == undefined"
                                                        class="pointer" @click="deleteAttachment(attachment,index)">
                                                        <i class="icon icon-close fs-16 closeAttachment"></i>
                                                    </div>
                                                    <div v-else class="pointer" @click="deleteAttachment(attachment,index)">
                                                        <i class="icon icon-close fs-16 closeAttachment"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-4">
                                        <div class="col-lg-12 text-center mt-10">
                                            <button class="btn btn-new-darkdanger btn-slight text-white mr-2"
                                                style="border-radius: 8px !important;min-width: 9.8rem;"
                                                @click="cancel()">Cancel</button>
                                            <button class="btn btn-new-darksuccess text-white btn-slight"
                                                style="border-radius: 8px !important;min-width: 9.8rem;"
                                                @click="save()">Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <save-sales-forecast modal_name="saveSalesForecast" :sales_forecast_id="sales_forecast_id"
            @closeSalesForecast="closeSalesForecast"></save-sales-forecast>
        <select-sales-forecast-dropdown v-if="selectDropdownModal" modal_name="selectSalesForecastDropdown"
            :type="dropdownType" :label="selectedLabel" @selected="selected" @close="selectDropdownModalClose">
        </select-sales-forecast-dropdown>
        <select-product-sale-forecast v-if="select_product_sales_forecast" modal_name="selectProductSalesForecast" @selectedProduct="selectedProduct">
        </select-product-sale-forecast>
        <select-sales-person-forecast v-if="select_sales_person_forecast" modal_name="selectSalesPersonForecast" @selectedSalesPerson="selectedSalesPerson">
        </select-sales-person-forecast>
        <select-u-m-forecast v-if="select_UM_forecast" modal_name="selectUMForecast" @selectedUM="selectedUM"></select-u-m-forecast>
    </div>
</template>
<script>
    import customer from "./mixins/customer";
    import uploadSalesforecasting from "./mixins/uploadSalesForecast.js";
    import globals from "./globals";
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import SaveSalesForecast from "./alertModals/SaveSalesForecast";
    import SelectSalesForecastDropdown from "./alertModals/SelectSalesForecastDropdown";
    import SelectProductSaleForecast from "./alertModals/SelectProductSaleForecast";
    import SelectSalesPersonForecast from "./alertModals/SelectSalesPersonForecast";
    import SelectUMForecast from "./alertModals/SelectUMForecast";
    export default {
        mixins: [customer, uploadSalesforecasting],
        data() {
            return {
                files: [],
                confirm_save_laoder: false,
                select_product_sales_forecast: false,
                select_sales_person_forecast: false,
                select_UM_forecast: false,
                images: [],
                audiovideo: [],
                attachments: [],
                dType: [{
                        id: "forecast",
                        name: "Forecast For Year",
                    },
                    {
                        id: "actual_sales",
                        name: "Current Sales For Year",
                    },
                ],
                deleteIds: [],
                selectAll: false,
                forecastYear: "",
                selectCompany: "",
                branchName: "",
                departmentName: "",
                mainSalesPerson: "",
                newtarget: {
                    reference: "MANUAL",
                    sales_person: "",
                    product: "",
                    product_code: "",
                    uom: "",
                    target: {
                        jan: 0,
                        jan_quantity: 1,
                        feb: 0,
                        feb_quantity: 1,
                        mar: 0,
                        mar_quantity: 1,
                        apr: 0,
                        apr_quantity: 1,
                        may: 0,
                        may_quantity: 1,
                        jun: 0,
                        jun_quantity: 1,
                        jul: 0,
                        jul_quantity: 1,
                        aug: 0,
                        aug_quantity: 1,
                        sept: 0,
                        sept_quantity: 1,
                        oct: 0,
                        oct_quantity: 1,
                        nov: 0,
                        nov_quantity: 1,
                        dec: 0,
                        dec_quantity: 1,
                    },
                },
                target: [{
                    reference: "MANUAL",
                    sales_person: "",
                    product: "",
                    product_code: "",
                    uom: "",
                    target: {
                        jan: 0,
                        jan_quantity: 1,
                        feb: 0,
                        feb_quantity: 1,
                        mar: 0,
                        mar_quantity: 1,
                        apr: 0,
                        apr_quantity: 1,
                        may: 0,
                        may_quantity: 1,
                        jun: 0,
                        jun_quantity: 1,
                        jul: 0,
                        jul_quantity: 1,
                        aug: 0,
                        aug_quantity: 1,
                        sept: 0,
                        sept_quantity: 1,
                        oct: 0,
                        oct_quantity: 1,
                        nov: 0,
                        nov_quantity: 1,
                        dec: 0,
                        dec_quantity: 1,
                    },
                }, ],
                forecastOrCurrent: "forecast",
                name: "",
                product_code: "",
                skip: 0,
                limit: 10,
                search_key: "",
                ajaxCallinprogress: false,
                notes: "",
                customers: [],
                branchs: [],
                departments: [],
                temp_customers: [],
                loadingCompany: false,
                loadingProducts: false,
                loadingSalesPerson: false,
                loadingUom: false,
                scrollable: false,
                count: 0,
                isVisible: false,
                totalOfMonth: {
                    jan: 0,
                    feb: 0,
                    mar: 0,
                    apr: 0,
                    may: 0,
                    jun: 0,
                    jul: 0,
                    aug: 0,
                    sept: 0,
                    oct: 0,
                    nov: 0,
                    dec: 0,
                },
                totalJan: [],
                totalFeb: [],
                totalMar: [],
                totalApr: [],
                totalMay: [],
                totalJun: [],
                totalJuly: [],
                totalAug: [],
                totalSept: [],
                totalOct: [],
                totalNov: [],
                totalDec: [],
                oldDate: "",
                oldDateValue: true,
                salesperson: [],
                quantityOnOff: true,
                uoms: [],
                productoptions: [],
                hide_el_dropdown: false,
                target_year: "Select Year",
                years_to_set: [],
                target_year_selected: "",
                show_multiselect: false,
                sales_forecast_id: "",
                dropdownType: "",
                selectedIndex: "",
                selectedLabel: "",
                selectDropdownModal: false,
            };
        },
        components: {
            HalfCircleSpinner,
            SaveSalesForecast,
            SelectSalesForecastDropdown,
            SelectProductSaleForecast,
            SelectSalesPersonForecast,
            SelectUMForecast
        },
        computed: {
            selectedCompany() {
                return this.$store.getters.selectedCompany;
            },
        },
        methods: {

            selectProductDropdown(index) {
                this.selectedIndex = index;
                this.select_product_sales_forecast = true;
                this.select_product_sales_forecast = true;
                setTimeout(() => {
                    this.$modal.show("selectProductSalesForecast");
                }, 500);
            },
            selectedProduct(option) {
                this.target[this.selectedIndex].product = option;
                this.target[this.selectedIndex].product_code = option.product_code;
                this.select_product_sales_forecast = false;
                this.$forceUpdate()
                this.errors.clear();
                this.$validator.reset();
            },
            selectSalesPersonDropdown(index) {
                this.selectedIndex = index;
                this.select_sales_person_forecast = true;
                setTimeout(() => {
                    this.$modal.show("selectSalesPersonForecast");
                }, 500);
            },
            selectedSalesPerson(option) {
                this.target[this.selectedIndex].sales_person = option;
                this.select_sales_person_forecast = false;
                this.errors.clear();
                this.$validator.reset();
            },
            selectUMDropdown(index) {
                this.selectedIndex = index;
                this.select_UM_forecast = true;
                setTimeout(() => {
                    this.$modal.show("selectUMForecast");
                }, 500);
                this.errors.clear();
                this.$validator.reset();
            },
            selectedUM(option) {
                this.target[this.selectedIndex].uom = option;
                this.select_UM_forecast = false;
            },
            selectDropdown(type, index, label) {
                this.dropdownType = type;
                this.selectedIndex = index;
                this.selectedLabel = label;
                this.selectDropdownModal = true;
                setTimeout(() => {
                    this.$modal.show("selectSalesForecastDropdown");
                }, 100);
            },
            selected(type, option) {
                if (type == "Product Name") {
                    this.target[this.selectedIndex].product = option;
                }
                if (type == "Sales Person") {
                    this.target[this.selectedIndex].sales_person = option;
                }
                if (type == "UM") {
                    this.target[this.selectedIndex].uom = option;
                }
            },
            selectDropdownModalClose() {
                document.getElementById("myAnchor").blur();
                this.selectDropdownModal = false;
            },
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace(",", ".");
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            deleteAll() {
                if (this.deleteIds.length == this.target.length) {
                    this.clearFewData();
                } else {
                    this.deleteIds.sort((a, b) => {
                        return b - a;
                    });
                    this.deleteIds.forEach(x => {
                        this.target.splice(x, 1);
                    });
                }
                this.selectAll = false;
                this.deleteIds = [];
                this.sumJan();
                this.sumFeb();
                this.sumMar();
                this.sumApr();
                this.sumMay();
                this.sumJun();
                this.sumJuly();
                this.sumAug();
                this.sumSep();
                this.sumOct();
                this.sumNov();
                this.sumDec();
            },
            checkYearChange() {
                if (this.oldDateValue) {
                    this.oldDate = this.target_year;
                    this.oldDateValue = false;
                }
                if (this.target[0].product != "") {
                    if (!this.oldDateValue) {
                        var d1 = new Date(this.oldDate);
                        var d2 = new Date(this.target_year);
                    }
                    this.$swal({
                        title: "WARNING !",
                        text: "There are Unsaved Changes",
                        type: "warning",
                        confirmButtonText: "DISCARD",
                        showCancelButton: true,
                        cancelButtonText: "CANCEL",
                        confirmButtonColor: "#005dae",
                    }).then(result => {
                        if (result.dismiss == "cancel") {
                            this.target_year = this.oldDate;
                        }
                        if (result.value) {
                            this.clearFewData();
                        }
                    });
                }
            },
            clearFewData() {
                this.totalOfMonth = {
                        jan: 0,
                        feb: 0,
                        mar: 0,
                        apr: 0,
                        may: 0,
                        jun: 0,
                        jul: 0,
                        aug: 0,
                        sept: 0,
                        oct: 0,
                        nov: 0,
                        dec: 0,
                    },
                    this.target = [{
                        reference: "MANUAL",
                        sales_person: "",
                        product: "",
                        product_code: "",
                        uom: "",
                        target: {
                            jan: 0,
                            jan_quantity: 1,
                            feb: 0,
                            feb_quantity: 1,
                            mar: 0,
                            mar_quantity: 1,
                            apr: 0,
                            apr_quantity: 1,
                            may: 0,
                            may_quantity: 1,
                            jun: 0,
                            jun_quantity: 1,
                            jul: 0,
                            jul_quantity: 1,
                            aug: 0,
                            aug_quantity: 1,
                            sept: 0,
                            sept_quantity: 1,
                            oct: 0,
                            oct_quantity: 1,
                            nov: 0,
                            nov_quantity: 1,
                            dec: 0,
                            dec_quantity: 1,
                        },
                    }, ];
            },
            cancel() {
                this.clearData();
            },
            clickedSelectAll() {
                this.selectAll = !this.selectAll;
                this.deleteIds = [];
                if (this.selectAll) {
                    this.target.forEach((t, index) => {
                        this.deleteIds.push(index);
                    });
                }
            },
            handleDeleteIds(index) {
                // this.deleteIds.forEach(x => {
                //     if (x === index) {
                //         this.deleteIds.splice(x, 1)
                //     } else{
                //         this.deleteIds.push(index)
                //     }
                // })
                if (this.deleteIds.find(i => i == index)) {
                    this.deleteIds = this.deleteIds.filter(x => x !== index);
                } else {
                    this.deleteIds.push(index);
                }
                if (
                    this.deleteIds.length === this.target.length &&
                    this.deleteIds.length !== 0 &&
                    this.target.length !== 0
                ) {
                    this.selectAll = true;
                } else {
                    this.selectAll = false;
                }
            },
            async updateBranch(co) {
                try {
                    let params = {
                        company_name: co.company_name,
                    };
                    let res = await this.$http.post(
                        "shadow_companies/get_branches",
                        params
                    );
                    this.branchs = res.data.response;
                    if (!res.data.is_shadow) {
                        this.departments = this.branchs[0].departments;
                    }
                } catch (reason) {}
            },
            clearBranchDept() {
                this.branchName = "";
                this.departmentName = "";
            },
            updateDept(branch) {
                this.departments = branch.departments;
            },
            sum(month) {
                let total = 0;
                this.target.forEach(x => {
                    total += x.target[`${month}_quantity`] > 0 ? x.target[month] * x.target[
                        `${month}_quantity`] : x.target[month];
                });
                this.totalOfMonth[month] = total;
            },
            disabledDays(value) {
                const date = new Date(value);
                const year = date.getFullYear();
                return year >= 2031;
            },
            yearNext() {
                let year = this.years_to_set[5];
                this.years_to_set = [];
                for (let i = 0; i < 6; i++) {
                    this.years_to_set.push(year + i);
                }
            },
            yearPrev() {
                let year = this.years_to_set[0];
                this.years_to_set = [];
                for (let i = 0; i < 6; i++) {
                    this.years_to_set.push(year - i);
                }
                this.years_to_set.reverse();
            },
            yearClicked(startyear, endyear) {
                this.target_year_selected = startyear + "-" + endyear;
            },
            applyFiscalYear() {
                this.hide_el_dropdown = true;
                this.target_year = this.target_year_selected;
            },
            dropdownTriggered(event) {
                if (!event) {
                    this.selectedFilter = "";
                }
                if (event) {
                    this.hide_el_dropdown = false;
                }
            },
            // createSaleForecast(){
            //   this.$router.push({ name: 'ListSalesForecast' })
            // },
            // goToNotification(){
            //   this.$router.push({ name: 'Notification' });
            //   window.location.reload()
            // },
            // goToAddNewUser(){
            //       this.$router.push({ name: 'AddNewUser' })
            // },
            async fetchCustomers(key) {
                this.loadingCompany = true;
                this.customers = [];
                if (key) {
                    this.search_key = key;
                };
                let res = await this.getCustomers({
                    skip: this.skip,
                    limit: this.limit,
                    search_key: this.search_key,
                });
                this.customers = res.response;
                this.loadingCompany = false;
            },
            async reachedEndOfListCustomer(reached) {
                this.isVisible = reached;
                if (reached && this.customers.length >= 10) {
                    if (this.scrollable == false) {
                        this.loadingCompany = true;
                        let res = await this.getCustomers({
                            skip: this.customers.length,
                            limit: this.limit,
                            search_key: this.search_key,
                        });
                        res.response.forEach(x => {
                            this.customers.push(x);
                        });
                        this.loadingCompany = false;
                    }
                }
            },
            convertDate(str) {
                var month, day, year, hours, minutes, seconds;
                var date = new Date(str),
                    month = ("0" + (date.getMonth() + 1)).slice(-2),
                    day = ("0" + date.getDate()).slice(-2);
                hours = ("0" + date.getHours()).slice(-2);
                minutes = ("0" + date.getMinutes()).slice(-2);
                seconds = ("0" + date.getSeconds()).slice(-2);

                var mySQLDate = [date.getFullYear()].join("-");
                return [mySQLDate].join(" ");
            },
            save() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.confirmSave();
                    }
                });
            },
            deleteAttachment(attachment, index) {
                this.attachments.splice(index, 1);
                document.getElementById("multiple").value = "";
                if (attachment.url == undefined) {
                    this.check_attachments = false;
                }
            },
            clearData() {
                this.selectCompany = "";
                this.branchName = "";
                this.departmentName = "";
                this.target_year = "";
                this.notes = "";
                this.forecastOrCurrent = "forecast";
                this.totalOfMonth = {
                    jan: 0,
                    feb: 0,
                    mar: 0,
                    apr: 0,
                    may: 0,
                    jun: 0,
                    jul: 0,
                    aug: 0,
                    sept: 0,
                    oct: 0,
                    nov: 0,
                    dec: 0,
                };
                this.target = [{
                    product: "",
                    product_code: "",
                    target: {
                        jan: 0,
                        feb: 0,
                        mar: 0,
                        apr: 0,
                        may: 0,
                        jun: 0,
                        jul: 0,
                        aug: 0,
                        sept: 0,
                        oct: 0,
                        nov: 0,
                        dec: 0,
                    },
                }, ];
                this.$router.push({
                    name: "ListSalesForecast"
                });
            },
            closeMultiselect() {
                this.skip = 0;
                this.search_key = "";
                this.show_multiselect = false;
            },
            async confirmSave() {
                this.confirm_save_laoder = true;
                try {
                    let params = {
                        customer_id: this.selectCompany._id,
                        branch: this.branchName._id,
                        department: this.departmentName,
                        target_year: this.target_year,
                        main_sales_person: this.mainSalesPerson._id,
                        forecast: this.target,
                        notes: this.notes,
                        document_type: this.forecastOrCurrent,
                        attachments: [],
                    };
                    params.forecast.forEach(x => {
                        x.sales_person = x.sales_person._id;
                        Object.assign(x, {
                            product_id: x.product._id,
                            category: x.product.category,
                            sub_category: x.product.sub_category,
                        });
                        x.product = x.product.name;
                    });
                    if (this.attachments.length) {
                        this.attachments.forEach(x => {
                            params.attachments.push({
                                name: x.name,
                                size: x.size,
                                url: x.url,
                            });
                        });
                    } else {
                        delete params["attachments"];
                    }
                    let res = await this.$http.post("sales_forecast/add", params);
                    if (res.data.status_id == 1) {
                        this.sales_forecast_id = res.data.sales_forecast_number;
                        this.$modal.show("saveSalesForecast");
                    }
                } catch (reason) {}
            },
            closeSalesForecast() {
                this.$validator.reset();
                this.errors.clear();
                this.clearData();
            },
            async getuom(key) {
                this.loadingUom = true;
                this.show_multiselect = true;
                if (key) {
                    this.search_key = key;
                };
                let params = {
                    search_key: this.search_key,
                    skip: 0,
                    limit: 10,
                };
                let res = await this.$http.post(
                    globals.SCM_API + "/fnb/scm/get_unit_of_measurements",
                    params
                );
                if (res.data.status_id == 1) {
                    this.uoms = [];
                    if (res.data.unit_of_measurements) {
                        res.data.unit_of_measurements.forEach(x => {
                            this.uoms.push(x.name);
                        });
                        this.loadingUom = false;
                    }
                } else {}
            },
            async getuomafter(reached) {
                if (reached) {
                    let params = {
                        search_key: this.search_key,
                        skip: this.uoms.length,
                        limit: 10,
                    };
                    let res = await this.$http.post(
                        globals.SCM_API + "/fnb/scm/get_unit_of_measurements",
                        params
                    );
                    if (res.data.status_id == 1) {
                        if (res.data.unit_of_measurements) {
                            res.data.unit_of_measurements.forEach(x => {
                                this.uoms.push(x.name);
                            });
                        }
                    } else {}
                };
            },
            async getProduts(key) {
                this.loadingProducts = true;
                this.show_multiselect = true;
                if (key) {
                    search_key = this.search_key;
                }
                let params = {
                    skip: 0,
                    limit: 10,
                    search: this.search_key,
                };
                let res = await this.$http.post(
                    globals.SCM_API + "/fnb/scm/get_product_listing_data",
                    params
                );
                if (res.data.status_id == 1) {
                    this.productoptions = [];
                    if (res.data.products) {
                        res.data.products.forEach(x => {
                            if ("name" in x) {
                                this.productoptions.push(x);
                            }
                        });
                        this.loadingProducts = false;
                    }
                }
            },
            async getProdutsAfter(reached) {
                if (reached && this.productoptions.length >= 10) {
                    let params = {
                        skip: this.productoptions.length,
                        limit: 10,
                        search: this.search_key,
                    };
                    let res = await this.$http.post(
                        globals.SCM_API + "/fnb/scm/get_product_listing_data",
                        params
                    );
                    if (res.data.status_id == 1) {
                        if (res.data.products) {
                            res.data.products.forEach(x => {
                                if ("name" in x) {
                                    this.productoptions.push(x);
                                }
                            });
                        }
                    }
                };
            },
            async fetchSalesPerson(key) {
                this.loadingSalesPerson = true;
                this.show_multiselect = true;
                let params = {
                    search_key: this.search_key,
                    skip: 0,
                    limit: 10,
                    company_id: this.selectedCompany._id,
                    active_status: "active",
                };
                let res = await this.$http.post("employees/get_employees", params);
                if (res.data.status_id == 1) {
                    this.salesperson = [];
                    res.data.response.forEach(x => {
                        this.salesperson.push(x);
                    });
                    this.loadingSalesPerson = false;
                }
            },
            async fetchSalesPersonAfter(reached) {
                if (reached) {
                    let params = {
                        search_key: this.search_key,
                        skip: this.salesperson.length,
                        limit: 10,
                        company_id: this.selectedCompany._id,
                        active_status: "active",
                    };
                    let res = await this.$http.post("employees/get_employees", params);
                    if (res.data.status_id == 1) {
                        res.data.response.forEach(x => {
                            this.salesperson.push(x);
                        });
                    }
                };
            },
            updateProductCode(option, index) {
                this.target[index].product_code = option.product_code;
            },
        },
        created() {
            for (let i = 0; i < 6; i++) {
                let year = new Date().getFullYear();
                this.years_to_set.push(year + i);
            };
            if (localStorage.hasOwnProperty("salesForecastType")) {
                this.forecastOrCurrent = "actual_sales";
            }
            const dict = {
                custom: {
                    product_name: {
                        required: () => "Product Name is Required"
                    },
                }
            }
            this.$validator.localize("en", dict);
        },
        destroyed() {
            localStorage.clear();
        }
    };
</script>
<style scoped>
    .sales_overflow {
        overflow-y: auto !important;
        overflow-x: auto !important;
    }

    .table_overflow {
        overflow-x: auto;
        overflow-y: auto;
    }

    .dateDisable {
        pointer-events: none !important;
    }

    .head {
        background-color: #005dae;
    }

    .salesForecasr-descHead {
        font-size: 15px;
        color: #303031;
        font-weight: 600;
    }

    .salesForecasr-desc {
        border-bottom: 1px solid #a9aaad;
        font-size: 14px;
        color: #303031;
        padding-bottom: 10px;
    }

    .btn-table {
        border-radius: 1px;
        border: dashed 1px #aaaaaa;
        background-color: rgba(214, 226, 239, 0.34);
        width: 100%;
        text-align: center;
        color: #303031;
        font-size: 14px;
        font-weight: 600;
        padding-top: 10px;
        padding-bottom: 10px;
        border-radius: 4px;
    }

    .btn-table:focus,
    .btn-table:active {
        outline: 0;
    }

    .category-manage-info {
        font-size: 12px;
        color: rgb(48, 48, 49);
        font-weight: 600;
        padding: 5px 10px;
        text-align: center;
        border: 2px solid rgb(13, 132, 242);
        border-radius: 18px;
        background-color: rgb(255, 255, 255);
        top: 51px;
        left: 0px;
        right: 0px;
        margin-left: auto;
        margin-right: auto;
        width: 200px;
        position: absolute;
        z-index: 9;
        text-transform: uppercase;
    }

    .callreportlist .page-content {
        background-color: transparent !important;
    }

    .kt-widget4 .kt-widget4__item {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding-top: 1rem;
        padding-bottom: 1rem;
        border-bottom: 0px solid transparent;
    }

    .kt-widget4 .kt-widget4__item:last-child {
        padding-bottom: 0;
        border-bottom: 0;
    }

    .kt-widget4 .kt-widget4__item .kt-widget4__img {
        margin-right: 2.5rem;
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 10px;
        width: 100px;
    }

    .kt-widget4 .kt-widget4__item .kt-widget4__info {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        padding-right: 1.25rem;
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
    }

    .kt-widget4 .kt-widget4__item .kt-widget4__title {
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        padding-right: 1.25rem;
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
        -webkit-transition: color 0.3s ease;
        transition: color 0.3s ease;
    }

    .kt-widget4 .kt-widget4__item .kt-widget4__info .kt-widget4__title {
        font-weight: 600;
        font-size: 14px;
        color: #fff;
    }

    .kt-widget14__legend {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }

    .kt-widget14__legend .kt-widget14__bullet {
        width: 2.5rem;
        height: 10.5px;
        border-radius: 2px;
    }

    .kt-widget14__legend .kt-widget14__bulletcircle {
        width: 18px;
        height: 18px;
        border-radius: 50%;
    }

    .btn-xlg {
        border-radius: 4px;
        text-transform: none;
        background-color: #0d5be6;
    }

    .kt-bg-success {
        background-color: #9debff !important;
    }

    .kt-bg-primary {
        background-color: #00448b !important;
    }

    .kt-bg-warning {
        background-color: #fdc72f !important;
    }

    .kt-widget14__legend .kt-widget14__stats {
        color: #fff;
        font-weight: 600;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        padding-left: 1rem;
        padding-right: 22px;
    }

    .kt-widget14__legend .kt-widget14__statsblack {
        color: #303031;
        font-weight: 600;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        padding-left: 1rem;
        padding-right: 22px;
    }

    .headerBlocksSales {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: stretch;
        -ms-flex-align: stretch;
        align-items: stretch;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        position: relative;
        padding: 0 22px;
        border-bottom: 0px solid transparent;
        min-height: 55px;
        line-height: 55px;
        border-radius: 10px 10px 0px 0px;
        background: #0b61fc;
    }

    .headerBlocksSales-label {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-line-pack: flex-first;
        align-content: flex-first;
    }

    .headerBlocksSales-label h3 {
        margin: 0;
        padding: 0;
        font-size: 18px;
        font-weight: 600;
        color: #fff;
    }

    .headerBlocksSales .head-toolbar {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-line-pack: end;
        align-content: flex-end;
    }

    .headerBlocksSalesHead {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: stretch;
        -ms-flex-align: stretch;
        align-items: stretch;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        position: relative;
        padding: 0 0px;
        border-bottom: 0px solid transparent;
        min-height: 30px;
        line-height: 30px;
        border-radius: 4.5px 4.5px 0px 0px;
        background: transparent;
    }

    .headerBlocksSalesHead-label {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-line-pack: flex-first;
        align-content: flex-first;
    }

    .headerBlocksSalesHead-label h3 {
        margin: 0;
        padding: 0;
        font-size: 18px;
        font-weight: 600;
        color: #fff;
    }

    .headerBlocksSalesHead .head-toolbar {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-line-pack: end;
        align-content: flex-end;
    }

    .headerBlocksWhite {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: stretch;
        -ms-flex-align: stretch;
        align-items: stretch;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        position: relative;
        padding: 0 2px 0px 2px;
        border-bottom: 1px solid transparent;
        min-height: 60px;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    }

    .headerBlocksWhite-label {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-line-pack: flex-first;
        align-content: flex-first;
    }

    .headerBlocksWhite-label h3 {
        margin: 0;
        padding: 0;
        font-size: 16px;
        font-weight: 600;
        color: #fff;
        padding-bottom: 6px;
    }

    .headerBlocksWhite .head-toolbar {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-line-pack: end;
        align-content: flex-end;
    }

    .mx-datepicker.date-white {
        width: 100px !important;
        position: relative !important;
        display: inline-block !important;
        color: #fff !important;
        font: 14px/1.5 "Poppins", sans-serif !important;
    }

    .mx-datepicker.date-white input {
        border-bottom: 1px solid #fff !important;
    }

    .mx-datepicker.date-white .mx-input-wrapper input.mx-input {
        height: 32px !important;
        color: #fff !important;
        font-weight: 600 !important;
        font-size: 13px !important;
    }

    .quarterValue {
        height: 34px;
        border: 0.5px solid #fff;
        border-radius: 5px;
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        padding: 6px 10px;
        display: block;
        width: 100%;
        text-align: center;
    }

    .yearPick {
        display: block;
        width: 100%;
        text-align: center;
    }

    .col-lg-20 {
        position: relative;
        width: 100%;
        min-height: 1px;
        padding-right: 15px;
        padding-left: 15px;
    }

    @media (min-width: 992px) {
        .quarterValue {
            text-align: center;
        }

        .yearPick {
            text-align: left;
        }

        .col-lg-20 {
            -webkit-box-flex: 0;
            -webkit-flex: 0 0 20%;
            -ms-flex: 0 0 20%;
            flex: 0 0 20%;
            max-width: 20%;
        }
    }

    text.apexcharts-text.apexcharts-datalabel-label {
        fill: #fff !important;
        font-family: "Poppins", sans-serif !important;
    }

    .apexcharts-pie-label,
    .apexcharts-datalabels,
    .apexcharts-datalabel,
    .apexcharts-datalabel-label,
    .apexcharts-datalabel-value {
        fill: #fff !important;
    }

    .page-salesforecast {
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        width: 100%;
        height: 100%;
    }

    .card {
        border-radius: 7px;
    }

    .kt-widget17__item {
        padding: 2rem;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        overflow: hidden;
        border-radius: 7px;
        background-color: #0019d6;
        margin: 0.3rem;
        /* -webkit-box-shadow: 0 1px 15px 1px rgba(69, 65, 78, 0.06);
  box-shadow: 0 1px 15px 1px rgba(69, 65, 78, 0.06); */
        cursor: pointer;
        -webkit-transition: all 0.3s ease;
        transition: all 0.3s ease;
        display: flex;
    }

    .kt-widget17__subtitle {
        display: block;
        font-size: 16px;
        color: #fff;
        font-weight: 600;
    }

    .kt-widget17__desc {
        font-size: 20px;
        color: #fff;
        font-weight: 600;
    }

    .kt-widget17__item .kt-widget17__month {
        font-weight: 600;
        text-align: right;
        position: absolute;
        right: 24px;
        top: 2px;
    }

    .img-forecast {
        padding: 10px;
        border-radius: 5px;
        background-image: linear-gradient(to bottom, #0086f8, #1c78f2 47%, #2d70ee);
    }

    .sales-header {
        text-align: left;
        color: #fff;
        font-weight: 600;
        font-size: 18px;
    }

    .four-col {
        border-radius: 7px;
        background-color: #0019d6;
        padding: 10px;
        color: #fff;
        font-weight: 600;
        margin: 26px 0px 1px 0px;
    }

    .card-salesForescast {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        background: #ffffff;
        /* -webkit-box-shadow: 0px 4px 5px -2px rgba(0, 0, 0, 0.2),
    0px 7px 10px 1px rgba(0, 0, 0, 0.14), 0px 2px 16px 1px rgba(0, 0, 0, 0.12); */
        /* box-shadow: 0px 4px 5px -2px rgba(0, 0, 0, 0.2),
    0px 7px 10px 1px rgba(0, 0, 0, 0.14), 0px 2px 16px 1px rgba(0, 0, 0, 0.12); */
        overflow: hidden;
        border-radius: 10px;
    }

    .first-cardsales {
        background-color: #fff;
        position: relative;
        top: 0px;
        border-radius: 10px;
        overflow: visible;
    }

    #chartdiv,
    #leads_funnel,
    #top_products {
        width: 100%;
        height: 500px;
    }

    #chartdiv2 {
        width: 100%;
        height: 300px;
    }

    #pie_middle_top {
        width: 100%;
        height: 200px;
    }

    /* .page-salesforecast .page-header {
    height: 430px;
    margin-bottom: 29%;
}
@media (min-width: 768px) {
  .page-salesforecast .page-header {
    height: 570px;
    margin-bottom: 29%;
  }
  .page-salesforecast .page-middle {
      margin-top: -90px;
      height: 890px;
  }
} */
    .inputFieldTableSales {
        font-size: 14px !important;
        padding: 15px 3px 5px 2px !important;
        display: block;
        width: 100%;
        border: none;
        border-bottom: solid 0.6px #a9aaad !important;
        background: transparent !important;
        color: #303031;
        font-weight: 600;
        display: block;
        width: 150px;
    }

    /* .forecastSumInput {
  padding-bottom: 1.6em;
} */
    .inputFieldTableSalesList {
        font-size: 14px !important;
        padding: 4px 4px 5px 2px !important;
        display: block;
        width: 100%;
        border: none;
        border-bottom: solid 0.6px #a9aaad !important;
        background: transparent !important;
        color: #303031;
        font-weight: 600;
        display: block;
        width: 100%;
        height: 34px;
    }

    .inputFieldTableSalesList::placeholder {
        color: #7b7f83 !important;
        font-size: 13px;
        overflow: visible;
    }

    .inputFieldTableSalesListError {
        color: #ed4040 !important;
        border-bottom: solid 0.6px #ed4040 !important;
    }

    .fiscal-year-el.el-dropdown-menu {
        right: 20px !important;
        width: 200px;
    }

    .table-new-template tbody tr td {
        padding: 0.5rem 1.2rem !important;
        vertical-align: top !important;
    }

    .createsfinput {
        padding-top: 2px;
        /* margin-left: 10px; */
    }
</style>



// WEBPACK FOOTER //
// src/components/CreateSalesForecast.vue